<div class="border">
  <div class="mb-4 flex items-center gap-3">
    <button *ngIf="isEdit"
      type="button"
      class="px-4 py-2 bg-blue-200 text-blue-700 rounded border-2 border-blue-700 shadow hover:bg-blue-50 transition disabled:opacity-50 disabled:cursor-not-allowed"
      (click)="addRow()"
      [disabled]="loading">
      <i class="pi pi-plus"></i> Add Row
    </button>
    <span *ngIf="loading" class="text-gray-500">
      <i class="pi pi-spinner pi-spin"></i> Loading...
    </span>
  </div>

  <p-table 
    [value]="documentsArray.controls" 
    [tableStyle]="{'min-width': '100%'}"
    [loading]="loading"
    styleClass="p-datatable-striped"
  >
    <ng-template pTemplate="header">
      <tr class="py-3 bg-slate-100">
        <th class="w-20 text-center font-semibold text-slate-700">Sr. No.</th>
        <th pSortableColumn="documentName" class="font-semibold text-slate-700">Document Name</th>
        <th pSortableColumn="description" class="font-semibold text-slate-700">Brief Description</th>
        <th class="font-semibold text-slate-700">Document Upload</th>
        <th *ngIf="isEdit" class="w-52 font-semibold text-slate-700">Next Action</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
      <tr [formGroup]="row" class="hover:bg-slate-50 border-b last:border-none">
        <td class="text-center align-middle">{{ rowIndex + 1 }}</td>
        
        <td>
          <input 
            type="text" 
            pInputText 
            formControlName="documentName"
            placeholder="Enter document name"
            class="block w-full px-3 py-2 border-2 border-slate-500 "
            [disabled]="editModeIndex !== rowIndex && row.get('id')?.value">
        </td>
        
        <td>
          <textarea 
            formControlName="description"
            placeholder="Enter brief description..."
            rows="2"
            class="block w-full px-3 py-2 border-2 border-slate-500 "
            [disabled]="editModeIndex !== rowIndex && row.get('id')?.value"></textarea>
        </td>
        
        <td>
          <input 
            type="file" 
            #fileInput
            (change)="onFileSelect($event, rowIndex)"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            class="hidden"
            [disabled]="editModeIndex !== rowIndex && row.get('id')?.value">
          <button
            type="button"
            class="inline-flex items-center px-3 py-1.5 border-2 border-blue-500 text-blue-700 rounded hover:bg-blue-50 transition text-sm font-medium mb-1"
            (click)="fileInput.click()"
            *ngIf="!(editModeIndex !== rowIndex && row.get('id')?.value) || loading">
            <i class="pi pi-upload"></i> Upload
          </button>
          <span *ngIf="row.get('file')?.value?.name" class="block mt-1 text-gray-500 text-xs">
            <i class="pi pi-file"></i> {{ row.get('file')?.value?.name }}
          </span>
          <span *ngIf="!row.get('file')?.value?.name && row.get('file')?.value && typeof row.get('file')?.value === 'string'" class="block mt-1 text-blue-600 text-xs">
            <a [href]="baseurl + row.get('file')?.value" target="_blank" class="underline hover:text-blue-800">
              <i class="pi pi-eye"></i> View File
            </a>
          </span>
        </td>
        
        <td *ngIf="isEdit">
          <div *ngIf="!row.get('isFileSave')?.value" class="flex gap-2">
            <button
              type="button"
              [ngClass]="editModeIndex === rowIndex 
                ? 'bg-green-600 text-white hover:bg-green-700' 
                : 'border border-blue-500 text-blue-700 hover:bg-blue-50 bg-white'"
              class="px-3 py-1.5 rounded text-sm font-medium transition disabled:opacity-50"
              (click)="editRow(rowIndex)"
              [attr.title]="editModeIndex === rowIndex ? 'Save' : 'Edit'"
              [disabled]="loading">
              <i class="pi pi-save"></i> {{editModeIndex === rowIndex ? 'Save' : 'Edit'}}
            </button>
            <button
              type="button"
              class="px-3 py-1.5 border-2 border-red-500 text-red-600 rounded text-sm font-medium bg-white hover:bg-red-50 transition disabled:opacity-50"
              (click)="deleteRow(rowIndex)"
              title="Delete"
              [disabled]="loading">
              <i class="pi pi-trash"></i> Delete
            </button>
          </div>
          <button *ngIf="row.get('isFileSave')?.value"
            type="button"
            class="px-3 py-1.5 border-2 border-blue-500 text-blue-700 rounded text-sm font-medium bg-white hover:bg-blue-50 transition disabled:opacity-50 mt-1"
            (click)="saveDocument(rowIndex)"
            title="Save"
            [disabled]="loading">
            <i class="pi pi-save"></i> Save
          </button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center text-gray-400 py-6 text-base">
          No documents added. Click <i class="pi pi-plus"></i> "Add Row" to start.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
